<template>
  <el-container>
    <el-header>
      <el-row>
        <el-alert
          title="Seccion para guardar formularios de los colaboradores de la empresa"
          type="info"
          effect="dark"
          show-icon
        >
        </el-alert>
      </el-row>
    </el-header>
    <vue-scroll class="page-dashboard">
      <el-main>
        <el-row>
          <el-col :span="24" :offset="0">
            <CustomersFilesUploader
              UploadHeader="Formularios"
              :DocumentType="5"
              :CompanyCode="this.currentCompany"
            />
          </el-col>
        </el-row>
      </el-main>
    </vue-scroll>
  </el-container>
</template>

<script>
import CustomersFilesUploader from "@/components/Company/OurCompanyFilesUploader.vue";

export default {
  name: "CustomerDetail",

  components: {
    CustomersFilesUploader
  }
};
</script>

<style scoped></style>
